// Согласие на cookies. Касается ТОЛЬКО веб-версии. С 30.09.2026 модель «продолжая
// пользоваться сайтом — согласие»: аналитика (Метрика, yclid) работает сразу, баннер
// с «ОК» лишь закрывается (CONSENT_ALL). CONSENT_NECESSARY остался у тех, кто нажал
// «Отклонить» в прежнем баннере, — им аналитику не включаем.
// В мини-аппах ТГ/Макс баннера нет — обработка аналитических данных покрыта
// политикой конфиденциальности, принимаемой при оформлении заказа (п. 6, 7.1).
// Ключ читается также inline-скриптом Метрики в public/index.html — при
// переименовании менять в обоих местах.

const KEY = 'stems_cookie_consent';

export const CONSENT_ALL = 'all';            // технические + аналитика
export const CONSENT_NECESSARY = 'necessary'; // только технические

// null → выбор ещё не сделан (показать баннер)
export function getCookieConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { status } = JSON.parse(raw);
    return status === CONSENT_ALL || status === CONSENT_NECESSARY ? status : null;
  } catch (e) {
    return null;
  }
}

export function saveCookieConsent(status) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ status, ts: Date.now(), v: 1 }));
  } catch (e) { /* no-op: приватный режим и т.п. — баннер покажется снова */ }
}
